import React, { useState, useEffect } from 'react';
import './FAQ.css';
import xIcon from '../../asserts/x.png';
import { supabase } from '../../supabaseClient';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    const getFaqs = async () => {
      const res = await supabase.from('faq_section').select('*').order('display_order');
      setFaqs(res.data || []);
    };
    getFaqs();
  }, []);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-title-row">
        <img src={xIcon} alt="Decorative X icon" className="faq-x" />
        <h2 className="faq-title">FREQUENTLY ASKED<br />QUESTIONS</h2>
        <img src={xIcon} alt="Decorative X icon" className="faq-x" />
      </div>

      <div className="faq-list">
        {faqs.map((item, index) => (
          <div className="faq-item" key={item.id}>
            <button
              className="faq-question"
              onClick={() => toggle(index)}
              aria-expanded={openIndex === index}
              aria-controls={`faq-answer-${index}`}
            >
              <span>{item.question_en}</span>
              <span className={`faq-arrow ${openIndex === index ? 'open' : ''}`}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </button>
            {openIndex === index && (
              <div className="faq-answer" id={`faq-answer-${index}`}>
                <p>{item.answer_en}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;